import React, { Component, ErrorInfo } from 'react';
import { Message }                     from 'semantic-ui-react';
import { DangerMessage }               from '../messaging/DangerMessage';
import { KeyedObject }                 from '../../../../types';

type ErrorBoundaryState = {
	hasError: boolean,
	error?: Error,
	errorInfo?: ErrorInfo,
}

export class ErrorBoundary extends Component<KeyedObject, ErrorBoundaryState> {
	
	public state: ErrorBoundaryState = {
		hasError:  false,
		errorInfo: null,
		error: null
	};
	
	public componentDidCatch( error: Error, errorInfo: ErrorInfo ){
		
		this.setState( {
			hasError: true,
			error,
			errorInfo
		} );
		
		// Log the error to an error reporting service
		// logErrorToMyService( hasError, errorInfo );
	}
	
	render(){
		
		let { hasError, error, errorInfo } = this.state;
		
		if( errorInfo ){
			
			// You can render any custom fallback UI
			return (
				<div className={ 'margin-md' }>
					<DangerMessage>
						<Message.Header content={ 'Something went wrong.' }/>
						<Message.Content>
							
							{ hasError && error.message && <p>{ error.message }</p> }
							
							<details style={ { whiteSpace: 'pre-wrap' } }>
								
								<summary>Stack Trace</summary>
								
								{ errorInfo.componentStack }
								
							</details>
						
						</Message.Content>
					</DangerMessage>
				</div>
			);
		}
		
		return this.props.children;
	}
}
